module.exports = __webpack_public_path__ + "img/Edit_Icon.1ed0e2b6.svg";